module.exports = __webpack_public_path__ + "static/img/home_product1@2x.58c6a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productIntroduction/home_product1@2x.png
// module id = oiGt
// module chunks = 0